import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest } from './ApiInstence';
import { toast } from 'react-toastify';

// Generator function
function* signinUser({ payload }) {
  try {
    let response = yield postRequest('admin/login', payload, {
      withCredentials: true, // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        data: { message: 'Cannot connect to backend server. Please try again later.' }
      }
    }
    if (response?.status == 200) {
      const userRole = response?.data?.user?.role;
      if (userRole !== 'admin') {
        toast.error('Access Denied: Only administrators can log in to the Admin Panel.');
        yield put(failed({ data: { message: 'Access Denied: Only administrators can log in here.' } }));
        return;
      }
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200 || response?.status == 201) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error)
    toast('Error signing up')
  }
}

// Watcher functions
export default function* apiHandler() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);
}